import React from "react";

export default React.createClass({
	render() {
		return (
			<div className="content-wrapper">
				<section className="content-header " style={{float:"left"}}>
			               	 <h1>欢迎来到后台管理平台！</h1>
			            </section>
		               </div>
		);
	}
})


// WEBPACK FOOTER //
// ./modules/home/Home.js